import React from "react";
import { Outlet } from "react-router-dom";

const LayoutAhorro = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default LayoutAhorro;
